import axios from 'axios';
import {ENV} from '../config/env';

export const apiClient = axios.create({
    baseURL: ENV.API_BASE_URL,
    timeout: 300000,
    headers: {
        'Content-Type': 'application/json',
    }
});